// extracted by mini-css-extract-plugin
module.exports = {"list":"e2ff468f85--list--_6P5H","list-item":"e2ff468f85--list-item--ubZLR"};